import isServerSide from '../../../../modules/is-server-side'

const onInitPiano = (callback) => {
  if (!isServerSide()) {
    window.tp = window.tp || []
    window.tp.push([
      'init',
      function () {
        callback()
      },
    ])
  }
}

export default onInitPiano
